// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b78527db","582":"2fde8a4a","727":"11644961"}[chunkId] + ".chunk.js";
};